"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const storageErrors = Object.freeze({
    GENERAL: "Storage error",
    PUT_ERROR: "Failed to save the data to storage",
    DELETE_ERROR: "Failed to delete item",
    GET_ERROR: "Failed to retrieve item",
    INIT_ERROR: "Failed to initialize store",
    CREATE_INDEX_ERROR: "Error creating index",
});
exports.default = storageErrors;
